import React from "react";
import { Classroom } from "lib/common/types/classroom";
import ContactInformation from "../contact/ContactInformation";
import "katex/dist/katex.min.css";
import ContentRenderer from "../ContentRenderer";

const tabs = ["Course Overview", "Contacts", "Payment Details"] as const;

function Overview({
  title,
  classRoom,
}: {
  title: string;
  classRoom: Classroom;
}) {
  const [activeTab, setActiveTab] =
    React.useState<(typeof tabs)[number]>("Course Overview");

  return (
    <section title={title} className="flex flex-col space-y-5">
      <div className="flex flex-wrap gap-2">
        {tabs.map((tab) => (
          <button
            key={tab}
            type="button"
            onClick={() => setActiveTab(tab)}
            className={
              activeTab === tab
                ? "rounded-full border border-primary bg-primary px-4 py-2 text-sm font-semibold text-white"
                : "rounded-full border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 transition hover:border-primary dark:hover:border-primary-300 hover:text-primary dark:hover:text-primary-300"
            }
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-5 sm:p-6">
        {activeTab === "Course Overview" && (
          (classRoom?.details ?? "").trim() ? (
            <div className="prose prose-sm sm:prose-base max-w-none text-gray-700 dark:text-gray-300 leading-relaxed">
              <ContentRenderer>{classRoom.details}</ContentRenderer>
            </div>
          ) : (
            <p className="text-sm text-gray-400 dark:text-gray-500 text-center py-4">
              Course details coming soon.
            </p>
          )
        )}

        {activeTab === "Contacts" && <ContactInformation />}

        {activeTab === "Payment Details" && (
          (classRoom?.paymentInstructions ?? "").trim() ? (
            <div className="prose prose-sm sm:prose-base max-w-none text-gray-700 dark:text-gray-300 leading-relaxed">
              <ContentRenderer>{classRoom.paymentInstructions}</ContentRenderer>
            </div>
          ) : (
            <p className="text-sm text-gray-400 dark:text-gray-500 text-center py-4">
              See the payment step below for accepted methods.
            </p>
          )
        )}
      </div>
    </section>
  );
}

export default Overview;
